/**
 * helixaction.js
 **/

import * as types from "../actiontypes";
import env from "../../util/env";

export function IsValidUserWithProjectAvailable(data) {
	const servieUrl = env.getBaseURL('Helix_Platform_Base_Url') + 'api/services/app/ExternalProject/' + 'IsValidUserWithProjectAvailable';
	return {
		type: types.IS_VALID_USER_WITH_PROJECT_AVAILABLE,
		meta: {
			api: {
				url: servieUrl,
				method: 'POST',
				headers: { 'CallerApp': 'fit', 'x-project-id': data.selectedProjectId },
				data: data
			},
			payload: data
		}
	};
}

export function cleanupValidUserWithProjectAvailableState() {
	return {
		type: types.CLEANUP_VALID_USER_WITH_PROJECT_AVAILABLE_STATE
	};
}
